// allows only letters , combining marks, whitespace, periods, apostrophes and hyphens
export const NAME_REGEX = new RegExp("^[\\p{L}\\p{M}\\s.'’-]+$", 'u')
